import { ModuleStatesConstructorsByName } from '@gongxigames/framework/slot/fragments/module/Module';
import { GameSessionPromotionDisabledState } from './GameSessionPromotionDisabledState';
import { GameSessionPromotionInitState } from './GameSessionPromotionInitState';
import { GameSessionPromotionStates } from '../GameSessionPromotionStates';
import { GameSessionPromotionEndState } from './GameSessionPromotionEndState';
import { GameSessionPromotionInProgressState } from './GameSessionPromotionInProgressState';
import { GameSessionPromotionStartState } from './GameSessionPromotionStartState';
import { GameSessionPromotionRestoreState } from './GameSessionPromotionRestoreState';

export const GameSessionPromotionStatesMap: ModuleStatesConstructorsByName = {
    [GameSessionPromotionStates.INIT]: GameSessionPromotionInitState,
    [GameSessionPromotionStates.RESTORE]: GameSessionPromotionRestoreState,
    [GameSessionPromotionStates.START]: GameSessionPromotionStartState,
    [GameSessionPromotionStates.IN_PROGRESS]: GameSessionPromotionInProgressState,
    [GameSessionPromotionStates.END]: GameSessionPromotionEndState,
    [GameSessionPromotionStates.DISABLED]: GameSessionPromotionDisabledState,
} as const;
